import React, { useMemo } from 'react'
import useCommon from 'src/hooks/useCommon'
import { orderGalleryPhotos } from 'src/utils/galleryOrder'
import { IConfiguration, ILocation, Maybe } from '../../types/graphql'
import ImagesV2 from '../Images/Images'

const getAlt = ({ shortAddress }: ILocation, locType: string): string =>
  `Fotografía real de un ${locType} que puedes rentar con SpotMe) de forma rápida y segura, ubicado en ${shortAddress}.`

interface ImagesWrapperProps {
  location: ILocation
  /** The configuration this listing URL is about — on a mixed
   *  storage + parking location its photos lead the gallery. */
  configuration?: Maybe<IConfiguration>
}

function Details({ location, configuration }: ImagesWrapperProps) {
  const { locMap } = useCommon()
  const locType = locMap(location)
  const photos = useMemo(
    () =>
      location.photos
        ? orderGalleryPhotos({
            photos: location.photos,
            activeConfiguration: configuration,
            configurations: location.configurations
          })
        : null,
    [location.photos, location.configurations, configuration]
  )

  if (!photos) return null

  return (
    <ImagesV2
      galleryId="galley-details"
      listingId={location.id}
      galleryTitle={`${locType} · ${location.shortAddress ?? ''}`}
      images={photos}
      showPages
      alt={getAlt(location, locType)}
    />
  )
}

export default React.memo(Details)
